/* tslint:disable */

declare var Object: any;
export interface SFChangeSpvInterface {
  "id"?: number;
}

export class SFChangeSpv implements SFChangeSpvInterface {
  "id": number;
  constructor(data?: SFChangeSpvInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFChangeSpv`.
   */
  public static getModelName() {
    return "SFChangeSpv";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFChangeSpv for dynamic purposes.
  **/
  public static factory(data: SFChangeSpvInterface): SFChangeSpv{
    return new SFChangeSpv(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFChangeSpv',
      plural: 'SFChangeSpvs',
      path: 'SFChangeSpvs',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFChangeSpv.ts